import type { SYSTableDef } from "../../../../_ovlclient/src/library/table/tableapi"

export let tblAudit: SYSTableDef = {
  id: "SYSAudit",
  title: {
    show: true,
    translationKey: "SYSAuditTitle",
    dialogTitle: { doNotDisplayId: true },
  },
  feature: undefined,
  database: {
    dataIdField: "Id",
  },
  server: {
    endpoint: "audit",
  },
  options: {
    initial_sort: { field: "Date", direction: "desc" },
    initial_paging: { page: 0, pageSize: 200 },
  },

  features: {
    filter: true,
  },
  columns: {
    Date: {
      type: "datetime",
      ui: { format: "timestamp_break" },
      sortable: true,
      filter: { rangeFilter: { selected: "none" } },
    },
    U_UserCode: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
    },
    U_User: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
    },
    U_Role: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
    },

    U_Operation: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
    },

    U_IDField: {
      sortable: true,
    },
    U_IDValue: {
      sortable: true,
    },
    U_TableName: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
    },
    U_Payload: { ui: { expandTableCellOnClick: true } },
  },
}
